import { Component } from '@angular/core';
import { IonicPage, ModalController, ViewController, NavController, ToastController, Events } from 'ionic-angular';
import { MobileDetectorProvider } from "../../providers/mobile-detector";
import { SearchService } from "../../providers/search.service";
import { IFilter, FilterService } from "../../providers/filter.service";
import { ApiService } from "../../providers/api.service";
import { ConfigService } from "../../providers/config.service";

@IonicPage({
  name: 'home'
})
@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  isLoading: boolean = true;
  objects: any = [];
  searchTerm: string = '';
  isMobile: boolean = window.innerWidth < 768;

  showWelcomeMessage: boolean = false;

  showSaveFilter: boolean = false;

  housingFilterCount: number;
  jobFilterCount: number;
  saleFilterCount: number;
  helpFilterCount: number;

  enableInfinite: boolean = true;

  hasSearchFilter: boolean = false;
  filterId: string = '';
  filter: IFilter;

  constructor(public navCtrl: NavController,
    private viewCtrl: ViewController,
    private modalCtrl: ModalController,
    private _mobileDetector: MobileDetectorProvider,
    private _searchService: SearchService,
    public _filterService: FilterService,
    private _apiService: ApiService,
    private toastCtrl: ToastController,
    private events: Events,
    public _config: ConfigService) {

    this._filterService.filterSubject.subscribe(filter => {
      this.filter = filter;
    });

    this._mobileDetector.isMobile.subscribe((data) => {
      this.isMobile = data;
    });

    this._searchService.searchStore.subscribe((data) => {
      if (data === null) return; // Initial data, no search results

      this.searchTerm = this._searchService.getSearchTerm();

      this.objects = data.results;
      this.isLoading = false;
      this.enableInfinite = true;

      this.housingFilterCount = data.num_housing;
      this.jobFilterCount = data.num_job;
      this.saleFilterCount = data.num_sale;
      this.helpFilterCount = data.num_help;
    });

    this._searchService.loadingStore.subscribe((data) => {
      this.isLoading = data;
    });

    this.events.subscribe('searchFilterClicked', () => {
      this.showSaveFilter = true;
    });

    this.refreshFilter();
  }

  ionViewWillEnter() {
    this._searchService.doSearch();
    this.viewCtrl.showBackButton(false);
  }

  disableShowWelcomeMessage() {
    localStorage.setItem('showWelcomeMessage', 'false');
    this.showWelcomeMessage = false;
  }

  getCardColor(type) {
    if (type === 'help') {
      return 'imarkt-app-cat-help';
    } else if (type === 'housing') {
      return 'imarkt-app-cat-housing'
    } else if (type === 'sale') {
      return 'imarkt-app-cat-sale'
    } else if (type === 'job') {
      return 'imarkt-app-cat-job'
    }
  }

  openDetail(data) {
    this.navCtrl.push('detail', {
      'type': data.type,
      'id': data.uuid
    })
  }

  getImageFiles(files) {
    return files.filter(f => !this.isPdf(f));
  }

  isPdf(file) {
    if (!file) return;
    let splits = file.split('.');
    return splits[splits.length - 1].toLowerCase().trim() === 'pdf';
  }

  getBackgroundUrl(object) {
    if (object) {
      if (object.files && object.files.length > 0) {
        let images = this.getImageFiles(object.files);
        if (images.length > 0) {
          return "url('" + this._config.baseUrl + '/' + images[0] + "')";
        }
      }
      return "url('/assets/category_" + object.type + ".png')";
    }
    return "url('')";
  }

  getBackgroundUrlStyle(object) {
    if (object) {
      if (object.files && object.files.length > 0) {
        let images = this.getImageFiles(object.files);
        if (images.length > 0) {
          return "cover";
        }
      }
      return "contain";
    }
    return "contain"; // TODO: Find cleaner solution
  }

  getSubtitle(type) {
    if (type === 'housing') {
      return 'WOHNRAUM';
    } else if (type === 'job') {
      return 'JOBS & PRAKTIKA';
    } else if (type === 'sale') {
      return 'MARKTPLATZ';
    } else if (type === 'help') {
      return 'ICH SUCHE DICH';
    }
  }

  getClass(type, isType) {
    let text = isType ? 'type' : 'category';

    if (type === 'housing') {
      return 'card--header__' + text + '__housing';
    } else if (type === 'job') {
      return 'card--header__' + text + '__job';
    } else if (type === 'sale') {
      return 'card--header__' + text + '__sale';
    } else if (type === 'help') {
      return 'card--header__' + text + '__help';
    }

  }

  doInfinite(infiniteScroll) {

    this._searchService.getNextPage().then((res: any) => {
      this.objects.push(...res.results);
      if (res.results.length < 20) {
        this.enableInfinite = false;
      }
      infiniteScroll.complete();
    }).catch(err => {
      this.enableInfinite = false;
      infiniteScroll.complete();
    });
  }

  refreshFilter() {
    this._apiService.getFilter().then((res: any) => {
      this.hasSearchFilter = res.objects.length !== 0;
      if (res.objects.length > 0) {
        this.filterId = res.objects[0].uuid;
      }
    }).catch(console.warn);
  }

  saveFilter() {
    this._filterService.saveFilterToServer().then(() => {
      this.refreshFilter();
    }).catch(console.warn);
  }

  deleteFilter() {
    this._apiService.deleteFilter(this.filterId).then(res => {
      this.presentToast('Suchabo erfolgreich gelöscht.');
      this.refreshFilter();
    }).catch(console.warn);
  }

  updateSearchFilter(ev) {
    this.showSaveFilter = !this.showSaveFilter;
  }

  presentToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: 'top'
    });

    toast.present();
  }

  onInput() {
    this._searchService.setSearchTerm(this.searchTerm);
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts